/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShopProductCreateDto } from '../../models/shop-product-create-dto';
import { ShopProductDto } from '../../models/shop-product-dto';

export interface ShopProductAdminControllerCreateV1$Params {
      body: ShopProductCreateDto
}

export function shopProductAdminControllerCreateV1(http: HttpClient, rootUrl: string, params: ShopProductAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ShopProductDto>> {
  const rb = new RequestBuilder(rootUrl, shopProductAdminControllerCreateV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShopProductDto>;
    })
  );
}

shopProductAdminControllerCreateV1.PATH = '/api/v1/shop-products/admin';
